"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryInfo = getCountryInfo;
exports.getCurrencyInfo = getCurrencyInfo;
exports.Currency = exports.Country = exports.Site = void 0;
var Site;
exports.Site = Site;

(function (Site) {
  Site["eechic"] = "eechic";
})(Site || (exports.Site = Site = {}));

var Country;
exports.Country = Country;

(function (Country) {
  Country["AUS"] = "AUS";
  Country["CAN"] = "CAN";
  Country["USA"] = "USA";
})(Country || (exports.Country = Country = {}));

var Currency;
exports.Currency = Currency;

(function (Currency) {
  Currency["USD"] = "USD";
  Currency["AUD"] = "AUD";
  Currency["GBP"] = "GBP";
  Currency["EUR"] = "EUR";
})(Currency || (exports.Currency = Currency = {}));

var countryList = [{
  country_id: "13",
  country_name: "Australia",
  country_title: "Australia",
  country_iso_code_2: "AU",
  country_iso_code_3: Country.AUS
}, {
  country_id: "38",
  country_name: "Canada",
  country_title: "Canada",
  country_iso_code_2: "CA",
  country_iso_code_3: Country.CAN
}, {
  country_id: "223",
  country_name: "United States",
  country_title: "United States",
  country_iso_code_2: "US",
  country_iso_code_3: Country.USA
}];
var currencyList = [{
  position: 1,
  currency_code: Currency.USD,
  currency_value: "1.00000000",
  sort_order: 1,
  symbol_left: "US $",
  currency_text: "US Dollar",
  currency_symbol: "$",
  symbol_right: "",
  decimal_point: ".",
  thousands_point: ",",
  decimal_places: "2"
}, {
  position: 36,
  currency_code: Currency.AUD,
  currency_value: "1.47000000",
  sort_order: 6,
  symbol_left: "AU $",
  currency_text: "Australian Dollar",
  currency_symbol: "$",
  symbol_right: "",
  decimal_point: ".",
  thousands_point: ",",
  decimal_places: "2"
}, {
  position: 38,
  currency_code: Currency.GBP,
  currency_value: "0.80000000",
  sort_order: 4,
  symbol_left: "£ ",
  currency_text: "British Pound",
  currency_symbol: "£",
  symbol_right: "",
  decimal_point: ".",
  thousands_point: ",",
  decimal_places: "2"
}, {
  position: 39,
  currency_code: Currency.EUR,
  currency_value: "0.89000000",
  sort_order: 3,
  symbol_left: "€ ",
  currency_text: "Euro",
  currency_symbol: "€",
  symbol_right: "",
  decimal_point: ".",
  thousands_point: ",",
  decimal_places: "2"
}];

function getCountryInfo(countryCode) {
  return countryList.find(function (v) {
    return v.country_iso_code_3 === countryCode;
  }) || null;
}

function getCurrencyInfo(currencyCode) {
  return currencyList.find(function (v) {
    return v.currency_code === currencyCode;
  }) || null;
}